import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  fonts: {
    heading: `'Reggae One', sans-serif`,
    body: `'Source Sans Pro', sans-serif`,
  },
  colors: {
    yakuza: {
      red: '#580303',
      darkRed: '#7f0d0d',
      black: '#202020',
      white: '#f5f5f5',
      paper: '#f8f0e3',
      gold: '#CDB88E',
      gray: '#333333',
      lightGray: '#666666',
    },
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: 'bold',
        borderRadius: '4px',
        _focus: {
          boxShadow: '0 0 0 3px rgba(88, 3, 3, 0.6)',
        },
      },
      variants: {
        solid: {
          bg: 'yakuza.red',
          color: 'yakuza.white',
          _hover: {
            bg: 'yakuza.darkRed',
            transform: 'translateY(-2px)',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
          },
        },
        outline: {
          bg: 'transparent',
          color: 'yakuza.red',
          border: '2px solid',
          borderColor: 'yakuza.red',
          _hover: {
            bg: 'yakuza.red',
            color: 'yakuza.white',
          },
        },
      },
    },
    Card: {
      baseStyle: {
        bg: 'rgba(32, 32, 32, 0.8)',
        border: '1px solid',
        borderColor: 'yakuza.red',
        borderRadius: '4px',
        p: 6,
        mb: 6,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.5)',
      },
    },
    Heading: {
      variants: {
        title: {
          fontWeight: 900,
          color: 'yakuza.white',
          letterSpacing: '1px',
          textTransform: 'uppercase',
          mb: 4,
          textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)',
        },
        subtitle: {
          fontWeight: 700,
          color: 'yakuza.gold',
          mb: 4,
        },
      },
    },
    Text: {
      variants: {
        highlight: {
          color: 'yakuza.white',
          fontWeight: 'bold',
        },
      },
    },
  },
  styles: {
    global: {
      body: {
        bg: 'yakuza.black',
        color: 'yakuza.white',
        backgroundImage: 'url("/banner.jpg")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
      },
      a: {
        color: 'yakuza.red',
        _hover: {
          textDecoration: 'underline',
        },
      },
    },
  },
});

export default theme;